/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Input_Position_Bottom_LeftInputs */



/**
* | output |
* | --- |
* | "Bottom Left" |
*
* @param {Input_Position_Bottom_LeftInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const input_position_bottom_left = /** @type {((inputs?: Input_Position_Bottom_LeftInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_Position_Bottom_LeftInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Bas Gauche")
	if (locale === "de") return /** @type {LocalizedString} */ ("Unten links")
	if (locale === "it") return /** @type {LocalizedString} */ ("In basso a sinistra")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Нижний левый угол")
	if (locale === "es") return /** @type {LocalizedString} */ ("Abajo a la izquierda")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("左下角")
	if (locale === "ja") return /** @type {LocalizedString} */ ("左下")
	if (locale === "hi") return /** @type {LocalizedString} */ ("तली छोड़ें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Canto inferior esquerdo")
	return /** @type {LocalizedString} */ ("Bottom Left")
});